import router from '@/router'
import { AppSidebar, AppHeader } from '@/components'
import { allowOnlyWithCompletedJourney } from '@/router/routerGuards'
import FooterOutgoingLinks from '@/components/FooterOutgoingLinks.vue'

export const routes = [
  {
    path: '/business-health/banking-insights',
    name: 'banking-insights',
    components: {
      default: () => import('./businessHealthInsights.vue'),
      sidebar: AppSidebar,
      header: AppHeader,
      footer: FooterOutgoingLinks
    },
    meta: {
      sitemap: {
        title: 'Banking insights',
        description: 'Cash flow patterns and transactions'
      },
      permissions: {
        roles: ['user'],
        redirectTo: {
          name: 'login'
        }
      }
    },
    props: {
      default: {
        reportId: '0d3fb006-5e20-4900-9554-bf0057f6d92d'
      }
    },
    beforeEnter: allowOnlyWithCompletedJourney()
  },
  {
    path: '/business-health/accounting-insights',
    name: 'accounting-insights',
    components: {
      default: () => import('./businessHealthInsights.vue'),
      sidebar: AppSidebar,
      header: AppHeader,
      footer: FooterOutgoingLinks
    },
    meta: {
      sitemap: {
        title: 'Accounting insights',
        description: 'Financial performance from accounting software'
      },
      permissions: {
        roles: ['user'],
        redirectTo: {
          name: 'login'
        }
      }
    },
    props: {
      default: {
        reportId: '1da1736b-d33e-4425-b97e-e65ec806106d'
      }
    },
    beforeEnter: allowOnlyWithCompletedJourney()
  }
]

export default () => {
  routes.forEach(route => router.addRoute(route))
}
